import * as React from 'react';
import { Card, CardContent, Typography }  from '@mui/material';
import { Tilt } from 'react-tilt';

export default function CardService(props) {
  return (
    <Tilt options={{ reverse: false, max: 35, perspective: 1e3, easing: "cubic-bezier(.03,.98,.52,.99)", scale: "1.05", speed: "1000", transition: true, axis: null, reset: true}}> 
      <Card sx={{ minWidth: 100}}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {props.title}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {props.description}
          </Typography>
        </CardContent>
      </Card>         
    </Tilt>
  );
}